var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmileyFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1347_8044)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 26,
    height: 25,
    rx: 6.25415,
    fill: "#CDCED6",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4142 15.6565C12.2815 15.6565 13.7952 14.1428 13.7952 12.2755C13.7952 10.4083 12.2815 8.89453 10.4142 8.89453C8.54693 8.89453 7.0332 10.4083 7.0332 12.2755C7.0332 14.1428 8.54693 15.6565 10.4142 15.6565Z",
    fill: "#060000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 7.95464C13.4044 7.95464 13.3199 7.92295 13.2459 7.85955C12.4747 7.14109 11.4709 6.73959 10.4144 6.73959C9.37892 6.73959 8.38575 7.13052 7.61446 7.82786C7.46654 7.96521 7.23409 7.95464 7.09674 7.80672C6.95939 7.6588 6.96995 7.42636 7.11787 7.28901C8.01595 6.46489 9.18874 6 10.4144 6C11.6611 6 12.8444 6.46489 13.7531 7.32071C13.901 7.45806 13.9116 7.6905 13.7742 7.83842C13.6897 7.91238 13.5946 7.95464 13.4995 7.95464Z",
    fill: "#060000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9951 12.2763C11.7712 12.2763 12.4003 11.6471 12.4003 10.871C12.4003 10.095 11.7712 9.46582 10.9951 9.46582C10.219 9.46582 9.58984 10.095 9.58984 10.871C9.58984 11.6471 10.219 12.2763 10.9951 12.2763Z",
    fill: "#FFFEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43166 13.8931C9.70025 13.8931 9.918 13.6754 9.918 13.4068C9.918 13.1382 9.70025 12.9204 9.43166 12.9204C9.16306 12.9204 8.94531 13.1382 8.94531 13.4068C8.94531 13.6754 9.16306 13.8931 9.43166 13.8931Z",
    fill: "#FFFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0861 15.6565C22.9534 15.6565 24.4671 14.1428 24.4671 12.2755C24.4671 10.4083 22.9534 8.89453 21.0861 8.89453C19.2188 8.89453 17.7051 10.4083 17.7051 12.2755C17.7051 14.1428 19.2188 15.6565 21.0861 15.6565Z",
    fill: "#060000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 7.95464C17.9051 7.95464 17.7995 7.91238 17.7255 7.83842C17.5882 7.6905 17.5882 7.45806 17.7466 7.32071C18.6553 6.46489 19.8386 6 21.0854 6C22.311 6 23.4838 6.45432 24.3819 7.28901C24.5298 7.42636 24.5404 7.6588 24.403 7.80672C24.2656 7.95464 24.0332 7.96521 23.8853 7.82786C23.1246 7.13052 22.1314 6.73959 21.0854 6.73959C20.0288 6.73959 19.0251 7.14109 18.2538 7.85955C18.1798 7.92295 18.0847 7.95464 18.0002 7.95464Z",
    fill: "#060000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5048 12.2763C21.2809 12.2763 21.9101 11.6471 21.9101 10.871C21.9101 10.095 21.2809 9.46582 20.5048 9.46582C19.7288 9.46582 19.0996 10.095 19.0996 10.871C19.0996 11.6471 19.7288 12.2763 20.5048 12.2763Z",
    fill: "#FFFEFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0576 13.8931C22.3262 13.8931 22.544 13.6754 22.544 13.4068C22.544 13.1382 22.3262 12.9204 22.0576 12.9204C21.789 12.9204 21.5713 13.1382 21.5713 13.4068C21.5713 13.6754 21.789 13.8931 22.0576 13.8931Z",
    fill: "#FFFEFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7503 20.2744C14.662 20.2744 13.6688 19.725 13.0877 18.8058C12.9821 18.6367 13.0349 18.4043 13.2039 18.2986C13.373 18.193 13.6054 18.2458 13.7111 18.4149C14.1548 19.1122 14.9156 19.5348 15.7397 19.5348C16.5638 19.5348 17.3245 19.1228 17.7683 18.4149C17.8739 18.2458 18.1064 18.193 18.2754 18.2986C18.4445 18.4043 18.4973 18.6367 18.3917 18.8058C17.8211 19.7356 16.8279 20.2744 15.7503 20.2744Z",
    fill: "#060000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1347_8044",
    x: 0.49834,
    y: 0,
    width: 31.0033,
    height: 30.0033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.50166
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1347_8044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1347_8044",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyFace);
export default __webpack_public_path__ + "static/media/smiley-face.6b7e96338c3353ea489dfe56b3e120a2.svg";
export { ForwardRef as ReactComponent };